module.exports = __webpack_public_path__ + "static/media/circled-s.7eacdce6.png";